import React from 'react'
import { Radio } from 'hljd'
export default (store, indexStore) => [
  {
    title: '选择',
    width: 50,
    dataIndex: 'id',
    render: (o, item) => {
      const { checked } = item
      return (
        <Radio
          checked={checked}
          onChange={() => store.toggleItemSelect(item, indexStore)}
        />
      )
    }
  },
  {
    title: '活动海报',
    width: 120,
    dataIndex: 'picture',
    render: picture => (
      <img
        src={`${
          picture.indexOf('?imageMogr2') > -1
            ? picture + '/thumbnail/90x160'
            : picture + '?imageView2/2/w/90/h/160'
        }`}
      />
    )
  },
  {
    title: '活动名称',
    width: 200,
    dataIndex: 'name'
  },
  {
    title: '当前报名数',
    width: 200,
    dataIndex: 'apply_num'
  }
]
